import React, {useMemo} from 'react';
import {useWindowDimensions, Linking} from 'react-native';
import RenderHTML from 'react-native-render-html';
import CCColors from '@/Utils/CCColors';
import {formattedTextToHtml} from '@/Utils/CommonUtils';
import {FontSizes} from '@/Utils/Dimensions';

const CCParsedMessage = ({text, style}) => {
  const {width} = useWindowDimensions();

  const html = useMemo(() => formattedTextToHtml(text.trim()), [text]);

  const fontSize = style?.fontSize ?? FontSizes[14];

  return (
    <RenderHTML
      contentWidth={width}
      source={{html}}
      baseStyle={{
        fontSize,
        lineHeight: fontSize * 1.1,
        color: style?.color ?? CCColors?.TextColor?.Primary,
      }}
      defaultTextProps={{
        selectable: true,
      }}
      tagsStyles={{
        p: {
          marginTop: 4,
          marginBottom: 4,
          fontSize,
          lineHeight: fontSize * 1.1,
        },
        ul: {
          marginTop: 4,
          marginBottom: 4,
          paddingLeft: 18,
        },
        ol: {
          marginTop: 4,
          marginBottom: 4,
          paddingLeft: 18,
        },
        li: {
          marginBottom: 4,
          paddingLeft: 2,
        },
        span: {
          fontSize,
          lineHeight: fontSize * 1.1,
        },
        strong: {
          fontWeight: '700',
        },
        em: {
          fontStyle: 'italic',
        },
        a: {
          color: CCColors.Level.Blue.Dark,
          textDecorationLine: 'underline',
        },
      }}
      renderersProps={{
        a: {
          onPress: (_, href) => href && Linking.openURL(href),
        },
      }}
    />
  );
};

export default CCParsedMessage;
